import {
    GET_TRAINING_TYPES_FAIL,
    GET_TRAINING_TYPES_SUCCESS,
    ADD_TRAINING_TYPE_SUCCESS,
    ADD_TRAINING_TYPE_FAIL,
    UPDATE_TRAINING_TYPE_SUCCESS,
    UPDATE_TRAINING_TYPE_FAIL,
    DELETE_TRAINING_TYPE_SUCCESS,
    DELETE_TRAINING_TYPE_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    trainingTypes: [],
    error: null,
    loading: true
};

const trainingTypeReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des trainingTypes
        case GET_TRAINING_TYPES_SUCCESS:
            return {
                ...state,
                trainingTypes: action.payload, // tableau d'objets trainingType
                loading: false,
                error: null
            };

        case GET_TRAINING_TYPES_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une trainingTypee
        case ADD_TRAINING_TYPE_SUCCESS:
            return {
                ...state,
                trainingTypes: [action.payload, ...state.trainingTypes], // ajoute au début du tableau
                error: null
            };

        case ADD_TRAINING_TYPE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Mise à jour d'une trainingTypee
        case UPDATE_TRAINING_TYPE_SUCCESS:
            return {
                ...state,
                trainingTypes: state.trainingTypes.map(trainingType =>
                    trainingType.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet trainingType
                        : trainingType
                ),
                error: null
            };

        case UPDATE_TRAINING_TYPE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Suppression d'une trainingTypee
        case DELETE_TRAINING_TYPE_SUCCESS:
            return {
                ...state,
                trainingTypes: state.trainingTypes.filter(
                    trainingType => trainingType.id !== action.payload
                ),
                error: null
            };


        case DELETE_TRAINING_TYPE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        default:
            return state;
    }
};

export default trainingTypeReducer;
